__turbopack_context__.v({
  "infoText": "GuestCustomerOnboardingModal-module-scss-module__-jbu7a__infoText",
  "modal": "GuestCustomerOnboardingModal-module-scss-module__-jbu7a__modal",
});
